import { lazy } from "react";
import withSuspense from "../../../helpers/withSuspense";
import LexicalSkeleton from "./LexicalSkeleton.jsx";

const MinimalLexicalEditor = withSuspense(lazy(() => import('./MinimalLexicalEditor.jsx')), LexicalSkeleton);

export default MinimalLexicalEditor;
